var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.860352H513V342.86H0V0.860352Z",
    fill: "#007C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 230.86H513V0.860352H0",
    fill: "#CE1720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 230.86V0.860352H0V342.86H513H100V230.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 160.46L8.60001 129.06L28 98.2603L47.3 129.06L28 160.46ZM72.6 160.46L53.3 129.06L72.6 98.2603L92 129.06L72.6 160.46ZM28 242.06L8.60001 210.66L28 179.86L47.3 210.66L28 242.06ZM72.6 242.06L53.3 210.66L72.6 179.86L92 210.66L72.6 242.06Z",
    fill: "#CE1720"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0092 16.4712L48.1184 48.6459L28.0093 81.3233L7.77441 48.6458L28.0092 16.4712ZM72.5908 16.4712L92.8256 48.6458L72.5907 81.3233L52.4816 48.6459L72.5908 16.4712ZM16.0256 48.6746L27.9907 67.9971L39.8816 48.6745L27.9908 29.6492L16.0256 48.6746ZM72.6092 29.6492L60.7184 48.6745L72.6093 67.9971L84.5744 48.6746L72.6092 29.6492ZM28.0092 260.571L48.1162 292.742L28.0093 325.542L7.77663 292.742L28.0092 260.571ZM72.5908 260.571L92.8234 292.742L72.5907 325.542L52.4838 292.742L72.5908 260.571ZM16.0234 292.778L27.9907 312.179L39.8838 292.778L27.9908 273.749L16.0234 292.778ZM72.6092 273.749L60.7162 292.778L72.6093 312.179L84.5766 292.778L72.6092 273.749Z",
    fill: "#CE1720"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.860352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBy);
export default __webpack_public_path__ + "static/media/BY.0b01a05b125a2e61608a18e41b2560c4.svg";
export { ForwardRef as ReactComponent };